import {Col} from "react-bootstrap";
import Question from "./Question";
import React from "react";
import {MM_QUESTION} from "../../scripts/myga-model";
import {validateCondition} from "../../scripts/validation";
import {PROCESS_QUESTION_TEXT_CLASSNAME} from "../../scripts/layout-manager";

export default function SubQuestions(props) {
  const {questions=[], anchorTo, handleChange, data} = props;

  const subQuestionFilter = q =>{
    if (anchorTo) {
      return (q[MM_QUESTION.anchorTo] === anchorTo) && validateCondition(q[MM_QUESTION.visibilityCondition],data);
    }
    return !q[MM_QUESTION.anchorTo] && validateCondition(q[MM_QUESTION.visibilityCondition],data);
  }

  return (
    <>
    {
      questions.filter(q => subQuestionFilter(q))
        .map((q,index)=>{
          let textClass = PROCESS_QUESTION_TEXT_CLASSNAME(q, 'question-label-pl-1')
          return (
            <Col className={`sub-question-container`} xs={12} key={index}>
              <Question containerClass={'p-0'}
                        question={q}
                        textClass={textClass}
                        onChange={handleChange}
                        data={data}/>
            </Col>
          )
      })
    }
    </>
  )
}